import { useParams } from "react-router-dom";
import { TableRowActionLink } from "~components/DataTable/components/TableRowActionLink/TableRowActionLink.tsx";

export const BroadcastsFixtureAction = ({ fixtureId }: { fixtureId: string }) => {
  const { customerId, sport, organizationId, seasonId } = useParams();

  return (
    <TableRowActionLink
      to={`/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/fixtures/${fixtureId}/broadcast`}
      back={`/${customerId}/admin/${sport}/${organizationId}/seasons/${seasonId}/fixtures`}
      icon={<i className="fas  fa-tower-broadcast mr-2" />}
      linkLabelIntl={"fixtureListPage.table.column.actions.broadcast"}
    />
  );
};
